import { Route } from 'vue-router';
import { Locale } from '@superbet-group/web.types';
import { getSchemaForRoute } from '../seo/schemaMarkup';

export function setDocumentTitle(title: string): void {
    window.document.title = title;
}

export function setMetaTitleDescription(title: string, description: string): void {
    setDocumentTitle(title);
    const desc = description.slice(0, 150).concat('...');
    const descElement = document.querySelector("[name='description']") as HTMLMetaElement;
    if (descElement) {
        descElement.content = desc;
    }
}

export function createCanonicalLink(canonicalUrl: string): void {
    // the canonicalUrl must be a full URL. ex. https://superbet.ro/some/path, not just the path /some/path
    document.querySelector('link[rel=canonical]')?.remove();
    const link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', canonicalUrl);
    document.head.appendChild(link);
}

export function updateRobotsMetaTag(to: Route, routerBase?: string): void {
    const disableIndexing
        = typeof to.meta?.disableIndexing === 'function'
            ? to.meta.disableIndexing(to)
            : to.meta?.disableIndexing;
    if (disableIndexing || routerBase === Locale.EnglishBrazilian.toLowerCase()) {
        const currentMetaRobots = document.querySelector('meta[name="robots"]');
        if (currentMetaRobots) {
            currentMetaRobots.remove();
        }
        const metaRobots = document.createElement('meta');
        metaRobots.name = 'robots';
        metaRobots.content = 'noindex';
        document.head.appendChild(metaRobots);
    } else {
        const metaRobots = document.querySelector('meta[name="robots"]');
        if (metaRobots) {
            metaRobots.remove();
        }
    }
}

export function updateSchema(to: Route) {
    const currentSchema = document.querySelector('[type="application/ld+json"]');
    if (currentSchema) {
        currentSchema.remove();
    }
    if (to.name) {
        const schema = getSchemaForRoute(to.name);
        if (schema) {
            const schemaTag = document.createElement('script');
            schemaTag.type = 'application/ld+json';
            schemaTag.textContent = schema;
            document.head.appendChild(schemaTag);
        }
    }
}
